"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockDiagramDocumentSchema = exports.BlockDiagramGenerationSchema = exports.BlockDiagramPlacementSchema = exports.BlockDiagramEdgeSchema = exports.BlockDiagramBlockSchema = exports.BlockDiagramVariantSchema = exports.EdgeKindSchema = exports.BlockKindSchema = exports.BLOCK_DIAGRAM_ATTACHMENT_TYPE = void 0;
const zod_1 = require("zod");
exports.BLOCK_DIAGRAM_ATTACHMENT_TYPE = 'block-diagram';
exports.BlockKindSchema = zod_1.z.enum(['processor', 'power', 'connector', 'other']);
exports.EdgeKindSchema = zod_1.z.enum(['rail', 'bus', 'control', 'analog']);
exports.BlockDiagramVariantSchema = zod_1.z.enum(['full', 'power', 'signal']);
exports.BlockDiagramBlockSchema = zod_1.z.object({
    id: zod_1.z.string().min(1),
    name: zod_1.z.string(),
    sub: zod_1.z.string().optional(),
    kind: exports.BlockKindSchema,
    refdes: zod_1.z.string().array().optional(),
    sheets: zod_1.z.string().array().optional(),
});
exports.BlockDiagramEdgeSchema = zod_1.z.object({
    from: zod_1.z.string().min(1),
    to: zod_1.z.string().min(1),
    kind: exports.EdgeKindSchema,
    label: zod_1.z.string().optional(),
    nets: zod_1.z.string().array().optional(),
    directed: zod_1.z.boolean().optional(),
    render: zod_1.z.boolean().optional(),
});
exports.BlockDiagramPlacementSchema = zod_1.z.object({
    hub: zod_1.z.string().optional(),
    cells: zod_1.z.record(zod_1.z.string(), zod_1.z.tuple([zod_1.z.number(), zod_1.z.number()])),
    spans: zod_1.z
        .record(zod_1.z.string(), zod_1.z.object({
        w: zod_1.z.number().positive().optional(),
        h: zod_1.z.number().positive().optional(),
    }))
        .optional(),
    spacing: zod_1.z.number().positive().optional(),
});
exports.BlockDiagramGenerationSchema = zod_1.z.object({
    generatedAt: zod_1.z.string(),
    projectId: zod_1.z.string(),
    buildId: zod_1.z.string(),
    rung: zod_1.z.number().int().min(1).max(3).optional(),
    skillVersion: zod_1.z.string().optional(),
    layoutEngineVersion: zod_1.z.string().optional(),
    generator: zod_1.z.string().optional(),
});
exports.BlockDiagramDocumentSchema = zod_1.z.object({
    schemaVersion: zod_1.z.literal(1),
    title: zod_1.z.string(),
    blocks: exports.BlockDiagramBlockSchema.array(),
    edges: exports.BlockDiagramEdgeSchema.array(),
    placement: exports.BlockDiagramPlacementSchema.optional(),
    generation: exports.BlockDiagramGenerationSchema,
});
//# sourceMappingURL=block-diagram-document.js.map